module.exports = __webpack_public_path__ + "static/media/twitter.44845c20.webp";